import React, { useState } from "react";
import { ReactComponent as FilterIcon } from "../../../../assets/icons/modal/filter.svg";
import { IBrand } from "../../../../types/brands.type";
import { ICategory } from "../../../../types/category.type";
import { IProductType } from "../../../../types/productType.type";
import {
  createSelectorBrands,
  createSelectorCategrory,
  createSelectorTypes,
} from "../../../../utils/createSelector";
import DefaultModal from "../../DefaultModal/DefaultModal";
import ModalBottomButtons from "../../forms/buttons/ModakBottomButtons/ModalBottomButtons";
import SelectInput, {
  SelectOption,
} from "../../forms/inputs/SelectInput/SelectInput";
import ModalTitle from "../../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: (
    brand: SelectOption,
    category: SelectOption,
    type: SelectOption
  ) => void;
  types: IProductType[];
  brands: IBrand[];
  category: ICategory[];
  defaultType: SelectOption;
  defaultCategory: SelectOption;
  defaultBrand: SelectOption;
}

const ProductsFilterModal: React.FC<Props> = (props) => {
  const typeSelector = createSelectorTypes(props.types);
  const categorySelector = createSelectorCategrory(props.category);
  const brandSelector = createSelectorBrands(props.brands);

  const [type, setType] = useState<SelectOption>(
    props.defaultType || typeSelector[0]
  );
  const [category, setCategory] = useState<SelectOption>(
    props.defaultCategory || categorySelector[0]
  );
  const [brands, setBrands] = useState<SelectOption>(
    props.defaultBrand || brandSelector[0]
  );
  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          title="Фільтр"
          subTitle='Виберіть параметри фільтра для відображення потрібних даних. Після налаштування натисніть "Застосувати" для отримання результату.'
          onClose={props.onClose}
        >
          <FilterIcon />
        </ModalTitle>
        <div className={styles.form}>
          <SelectInput
            title="Бренд"
            value={brands}
            values={brandSelector}
            onChange={(value) => setBrands(value)}
          />
          <SelectInput
            title="Категорія"
            value={category}
            values={categorySelector}
            onChange={(value) => setCategory(value)}
          />
          <SelectInput
            title="Тип"
            value={type}
            values={typeSelector}
            onChange={(value) => setType(value)}
          />
        </div>
        <ModalBottomButtons
          onPressApply={() => {
            props.onApply(brands, category, type);
            props.onClose();
          }}
          onPressBack={props.onClose}
          backTitle="Назад"
          applyTitle="Застосувати"
        />
      </div>
    </DefaultModal>
  );
};

export default ProductsFilterModal;
